import { Route, Switch } from "react-router-dom";

import H22025RgXpImpactCalendarPage from "@faire/prototype-playground/workspace/pp/rg-f-30-d-xp-impact-calendar";

export function PauloPintoRoutes() {
  return (
    <Switch>
      <Route path="/pp/rg-f-30-d-xp-impact-calendar" component={H22025RgXpImpactCalendarPage} />
    </Switch>
  );
}

export const slug = "pp";
